export default {
	title: "Retornos",
	newReturn: "Novo Retorno",
	fulfill: "Cumprir",
	fulfilled: "Cumprido",
	pending: "Pendente",
	debit: "Debitar",
	delete: "Excluir",
	deleteConfirmTitle: "Excluir retorno?",
	deleteConfirmText: "Esta ação não pode ser desfeita.",
	noReturns: "Nenhum retorno",
	returnType: {
		RESERVATION: "Reserva",
		NEXT_RITUAL: "Próximo Ritual",
		SPECIFIC_RITUAL: "Ritual Específico",
		SPECIFIC_DATE: "Data Específica",
		COUNTER: "Contador",
		INDEFINITE: "Indefinido",
	},
	fields: {
		person: "Pessoa",
		type: "Tipo",
		target: "Destino",
		status: "Situação",
		notes: "Observações",
	},
	form: {
		returnTypeRequired: "Tipo de retorno é obrigatório",
		targetAttendanceTypeRequired: "Informe o tipo de ficha",
	},
	messages: {
		created: "Retorno criado com sucesso",
		fulfilled: "Retorno cumprido",
		debited: "Retorno debitado: {remaining}/{total}",
		deleted: "Retorno removido",
		createError: "Erro ao criar retorno",
		debitError: "Erro ao debitar retorno",
		deleteError: "Erro ao remover retorno",
		fulfillError: "Erro ao cumprir retorno",
		loadError: "Erro ao carregar retornos",
	},
};
